<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal size="md" :visible="modal.show" scrollable
                   :title="$t('Toggle Columns')" @show="onShow"
                   @hidden="onHidden" @ok.prevent="onSubmit" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading" modal-class="mobile-full-screen">
      <b-form-checkbox-group v-model="selectedOptionValues" stacked>
        <draggable :list="availableOptions" handle=".handle">
          <div v-for="item in availableOptions" class="d-flex" :key="item.value">
            <font-awesome-icon class="icon handle drag-icon" icon="bars"/>
            <b-form-checkbox class="pb-3 ml-2"  :value="item.value">
              {{ item.text }}
            </b-form-checkbox>
          </div>
        </draggable>
      </b-form-checkbox-group>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import cloneDeep from "lodash/cloneDeep";
  import draggable from "vuedraggable";
  import BatchLotUpV2Service from "@/modules/sales/batch-lot-up-v2/BatchLotUpV2Service";

  const {mapState, mapActions} = createNamespacedHelpers('sales/batchLotUpV2');
  const {mapState: globalState} = createNamespacedHelpers('global');

  export default {
    name: "BLUV2ToggleColumnsModal",
    components: {
      ArtisioModal, draggable
    },
    data() {
      return {
        loading: false,
        errorMessage: null,
        showConfirmation: false,
        availableOptions: [],
        selectedOptionValues: []
      }
    },
    computed: {
      ...mapState({
        modal: state => state.toggleColumnsModal,
      }),
      ...globalState({
        uniqueDynamicFields: state => state.uniqueDynamicFields,
      }),
    },
    methods: {
      ...mapActions(['hideToggleColumnsModal']),
      onShow() {
        this.showConfirmation = true
        this.initData()
      },
      onHidden() {
        this.availableOptions = []
        this.selectedOptionValues = []
        this.$emit('hidden')
        this.hideToggleColumnsModal();
      },
      async onSubmit() {
        let tmpSelectedColumns = []
        for (let item of this.availableOptions) {
          if (this.selectedOptionValues.includes(item.value)) {
            tmpSelectedColumns.push(item.value)
          }
        }
        BatchLotUpV2Service.setColumns(tmpSelectedColumns)
        this.hideToggleColumnsModal()
      },
      initData() {
        let tmpAvailableOptions = cloneDeep(this.uniqueDynamicFields)
        let tmpArr = []

        let savedValues = BatchLotUpV2Service.getColumns()
        for (let dfKey of savedValues) {
          if (tmpAvailableOptions[dfKey]) {
            tmpArr.push({
              ...tmpAvailableOptions[dfKey],
              text: tmpAvailableOptions[dfKey].displayName || tmpAvailableOptions[dfKey].label,
              value: dfKey
            })
          }
        }

        for (let dfKey in tmpAvailableOptions) {
          if (!savedValues.includes(dfKey)) {
            tmpArr.push({
              ...tmpAvailableOptions[dfKey],
              text: tmpAvailableOptions[dfKey].displayName || tmpAvailableOptions[dfKey].label,
              value: dfKey
            })
          }
        }

        this.selectedOptionValues = savedValues
        this.availableOptions = tmpArr
      }
    }
  }
</script>

<style scoped>
  .drag-icon {
    font-size: 1.2em;
    cursor: move;
    margin-top: 2px;
  }
</style>
